// extracted by mini-css-extract-plugin
export default {"wrap":"OrderListRow_wrap__vcHtY","imgWrap":"OrderListRow_imgWrap__yuhkR","border":"OrderListRow_border__GQWqU","trackButton":"OrderListRow_trackButton__Ym83L"};